// Environment Variables Override - Force API URL
// Ten plik zapewnia że ZAWSZE używamy api.plexisystem.pl

// Jeśli to produkcja, wymuś prawidłowy URL
if (typeof window !== 'undefined' && window.location.hostname === 'app.plexisystem.pl') {
  // Nadpisz wszystkie możliwe zmienne
  const PRODUCTION_API_URL = 'https://api.plexisystem.pl';
  
  // Nadpisz import.meta.env
  if (import.meta && import.meta.env) {
    Object.defineProperty(import.meta.env, 'VITE_API_URL', {
      value: PRODUCTION_API_URL,
      writable: false,
      configurable: false
    });
  }
  
  // Ustaw globalnie
  (window as any).API_URL = PRODUCTION_API_URL;
  (window as any).VITE_API_URL = PRODUCTION_API_URL;
  (window as any)._PLEXISYSTEM_API = PRODUCTION_API_URL;
  
  console.log('🔧 Forced API URL to:', PRODUCTION_API_URL);
}

export {};